import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { Error404Component } from './errors/error404/error404.component'
import { AboutComponent } from './pages/about/about.component'
import { ComparatorComponent } from './pages/comparator/comparator.component'
import { HomeComponent } from './pages/home/home.component'
import { IndicatorsComponent } from './pages/indicators/indicators.component'
import { IncentiveDatabaseComponent } from './pages/incentive-database/incentive-database.component'
import { CountryDetailComponent } from './resources/country/country-detail/country-detail.component'
import { CountryListComponent } from './resources/country/country-list/country-list.component'
import { IncentiveDetailComponent } from './resources/incentive/incentive-detail/incentive-detail.component'

const routes: Routes = [
  // Pages.
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'comparator',
    component: ComparatorComponent
  },
  {
    path: 'indicators-and-analysis',
    component: IndicatorsComponent
  },
  {
    path: 'incentives',
    component: IncentiveDatabaseComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },

  { path: 'countries', component: CountryListComponent },
  { path: 'countries/:code', component: CountryDetailComponent },
  { path: 'incentives/:id', component: IncentiveDetailComponent },
  {
    path: '404',
    component: Error404Component
  },
  {
    path: '**',
    redirectTo: '/404'
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
